import { type Common } from '../common.js';
import type {
  BaseHumanTaskCategoryUser,
  HumanTaskCategoryUser,
  HumanTaskCategoryUsersParams,
} from '../models/flow/humanTask/humanTaskCategory.js';
import { isTruthy } from '../utils.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/human-task-categories/:categoryId/users';

  constructor(common: Common) {
    this.common = common;
  }

  getBaseEndpoint(categoryId: string) {
    return this.baseEndpoint.replace(':categoryId', categoryId);
  }

  async findAll(params?: HumanTaskCategoryUsersParams): Promise<HumanTaskCategoryUser[]> {
    const { categoryId, ...queryParams } = params ?? {};
    if (!isTruthy(categoryId)) {
      throw new Error('categoryId is required');
    }
    const url = this.common.constructPath(this.getBaseEndpoint(categoryId), queryParams);
    return await this.common.getJSON(url);
  }

  async create(props: {
    categoryId: string;
    newCategoryUser: Omit<BaseHumanTaskCategoryUser, 'categoryId'>;
  }): Promise<HumanTaskCategoryUser> {
    const url = this.common.constructPath(this.getBaseEndpoint(props.categoryId));
    return await this.common.postJSON(url, props.newCategoryUser);
  }

  async delete(props: { categoryId: string; userId: string }): Promise<{ success: boolean }> {
    const url = this.common.constructPath(
      `${this.getBaseEndpoint(props.categoryId)}/${props.userId}`
    );
    return await this.common.deleteJSON(url);
  }
}
